// extracted by mini-css-extract-plugin
export default {"container":"QuestionTable_container__XRUzB","header":"QuestionTable_header__PgN6s","correctAnswerText":"QuestionTable_correctAnswerText__Ikb6P","rank":"QuestionTable_rank__3tZAO"};